export const HEADER_GRADIENT = "linear-gradient(135deg, #0d1a3a 0%, #1a2f6e 35%, #3a1a6e 65%, #c0392b 100%)"
export const LAUNCH_GRADIENT = "linear-gradient(135deg, #1a2f6e 0%, #3a1a6e 60%, #8B1A2E 100%)"
export const LAUNCH_GRADIENT_HOVER = "linear-gradient(135deg, #152760 0%, #30156a 60%, #7a1528 100%)"

// The big pill that launches the assistant on the program guide; the schedule builder's launch
// button next to it takes the same props.
export const LAUNCH_BUTTON_PROPS = {
    h: "64px",
    px: "36px",
    borderRadius: "full",
    background: LAUNCH_GRADIENT,
    color: "#fff",
    fontSize: "17px",
    fontWeight: "600",
    letterSpacing: "0.01em",
    gap: "12px",
    boxShadow: "0 6px 24px rgba(26,47,110,0.35), 0 2px 8px rgba(0,0,0,0.12)",
    _hover: {
        background: LAUNCH_GRADIENT_HOVER,
        boxShadow: "0 8px 28px rgba(26,47,110,0.45)",
        transform: "translateY(-1px)",
    },
    transition: "all 0.18s ease",
}
// Chatbot header text; the second line comes from Craft's `agentSubtitle`, falling back to this.
export const HEADER_TITLE = "ASK EMMA"
export const DEFAULT_AGENT_SUBTITLE = "Your AI Assistant"
export const NAVY = "#1B3B6F"
// Inline session card accents
export const CARD_ACCENT_RED = "#C0392B"
export const CARD_ACCENT_PURPLE = "#3A1A6E"
export const BOT_BUBBLE_BG = "#EEF4FF"
export const PAGE_BG = "#FAFBFC"
export const BORDER_COLOR = "#E2E8F0"
export const META_COLOR = "#768293"
export const TITLE_COLOR = "#1E293B"
export const SUBTLE_BG = "#F8FAFC"

// currently unused
export const SUGGESTED_QUESTIONS = [
    "Who is giving the keynote address?",
    "What's happening in the Main Arena room on Sunday morning?",
    "When are the Nurse and Technologist sessions?",
    "What sessions discuss AI at TCT?",
]

// Error code /api/ai/chat returns when the agent rejects the conversation's history as too long.
export const CONVERSATION_TOO_LONG = "conversation_too_long"
